/**
 * Lightens a hex color towards white by the given factor (> 1 = lighter).
 * Returns a fallback lime green if the input is not a valid 6-digit hex.
 */
export function adjustBrightness(hex: string, factor: number): string {
  if (!hex || typeof hex !== 'string') return '#a3e635';
  const cleanHex = hex.startsWith('#') ? hex.substring(1) : hex;
  if (!/^[0-9A-F]{6}$/i.test(cleanHex)) return '#a3e635';
  const num = parseInt(cleanHex, 16);
  const amt =
    Math.round(Math.min(255, Math.max(0, (num >> 16) + (255 - (num >> 16)) * (1 - 1 / factor)))) << 16 |
    (Math.round(Math.min(255, Math.max(0, ((num >> 8) & 0xff) + (255 - ((num >> 8) & 0xff)) * (1 - 1 / factor)))) << 8) |
    Math.round(Math.min(255, Math.max(0, (num & 0xff) + (255 - (num & 0xff)) * (1 - 1 / factor))));
  return '#' + ('0000' + amt.toString(16)).slice(-6);
}
